import { Typography, type TypographyProps } from "@mui/material";
import merge from "lodash/merge";

import type { FC, PropsWithChildren } from "react";

export const SectionTitle: FC<PropsWithChildren<TypographyProps>> = (props) => {
  return (
    <Typography
      variant="h3"
      color="translucent.black.100"
      {...props}
      sx={merge({ typography: { sm: "h2" } }, props?.sx)}
    />
  );
};
